import styled from 'styled-components';


export const CursoHeroContainer = styled.div`
  width: 100%;
  background-color: #02391E;
  padding: 60px 0;
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoBox = styled.div`
  padding-right: 20px;

  @media screen and (max-width: 768px) {
    padding-right: 0;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Logo = styled.img`
  width: 280px;
  display: block;
  margin: 0 auto 40px auto;
`;

export const Title = styled.h1`
  color: #ffffff;
  font-size: 36px;
  font-weight: 400;
  line-height: 1.3;
  margin-bottom: 20px;
`;

export const Subtitle = styled.p`
  color: #ffffff;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 30px;
`;

export const ButtonWrapper = styled.div`
  text-align: center;
`;

export const CursoButton = styled.a`
  display: inline-block;
  background-color: #FED15D;
  color: #02391E;
  font-weight: 700;
  text-decoration: none;
  padding: 15px 40px;
  border-radius: 30px;
  border: 2px solid #FED15D;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background-color: #02391E;
    color: #FED15D;
    border-color: #FED15D;
    transform: translateY(-3px);
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  }
`;

export const ImageBox = styled.div`
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    display: block;
  }

  @media screen and (max-width: 768px) {
    text-align: center;
  }
`;


export const EssentialSection = styled.section`
  background-color: #ffffff;
  padding: 0px 0 0;
`;

export const EssentialTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;

  @media screen and (max-width: 768px) {
    padding-left: 0;
    align-items: center;
    text-align: center;
    margin-top: 30px;
  }
`;

export const EssentialTitle = styled.h2`
  color: #02391E;
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 20px;
`;

export const EssentialParagraph = styled.p`
  color: #02391E;
  font-size: 22px;
  line-height: 1.6;
`;


export const LearningSection = styled.section`
  background-color: #f7f7f7; 
  padding: 0px 0 40px; 
`;

export const SectionTitle = styled.h2`
  color: #02391E;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 50px;
`;

export const LearningGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 350px);
  column-gap: 100px;
  row-gap: 40px;
  
  justify-content: center; 

  @media screen and (max-width: 992px) {
     grid-template-columns: repeat(2, 280px);
  }

  @media screen and (max-width: 576px) {
       grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const LearningCard = styled.div`
  background-color: #02391E;
  color: #ffffff;
  padding: 20px;
  border-radius: 30px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  min-height: 80px;
  max-width: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
    cursor: pointer;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
  }
`;

export const ForWhomSection = styled.section`
  position: relative;
  background-image: url('/Curso/imagem-curso-4.png');
  background-size: cover;
  background-position: center;
  padding: 80px 0;
  
  
  background-attachment: fixed;

  .container {
    position: relative;
    display: flex;
    justify-content: flex-end; 
  
    padding-right: 50px; 
  }
`;

export const ForWhomContent = styled.div`
  width: 45%; 
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  
  

  @media screen and (max-width: 992px) {
    width: 60%; 
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    align-items: center; 
  }
`;

export const ForWhomTitle = styled.h2`
  color: #02391E;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
  text-align: right;

  @media screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const ForWhomCard = styled.div`
  background-color: #ffffff;
  color: #02391E;
  border-radius: 20px;
  padding: 15px 25px;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px; 
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  
  width: 50%; 
  text-align: center;

  @media screen and (max-width: 768px) {
    text-align: center;
    width: fit-content;
  }
`;



export const InvestmentSection = styled.section`
  background-color: #ffffff;
  padding: 20px 0;
  text-align: center;
`;

export const InvestmentTitle = styled.h2`
  color: #02391E;
  font-size: 60px;
  font-weight: 700; 
  margin-bottom: 20px;
`;

export const InvestmentParagraph = styled.p`
  color: #02391E;
  font-size: 40px;
  max-width: 800px;
  margin: 0 auto 30px auto;
`;


export const PriceText = styled.p`
  color: #FFC85E;
  font-size: 74px;
  font-weight: 700;
  margin-bottom: 40px;
  text-shadow: 4px 2px 5px #02391E;
  
`;

export const TestimonialsSection = styled.section`
  position: relative;
  padding: 80px 0;
  background-image: url('/Curso/imagem-curso-7.png');
  background-attachment: fixed; 
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
`;

export const TestimonialsTitle = styled.h2`
  color: #02391E;
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 60px;
`;

export const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  

  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
    max-width: 600px;
  }
`;

export const TestimonialCard = styled.div`
  color: #02391E;
  font-size: 19px;
  line-height: 1.6;
  font-weight: 500;
`;


export const ContactCtaSection = styled.section`
  background-color: #ffffff;
  padding: 20px 20px 40px 40px;
`;

export const FinalTwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
   gap: 60px;

  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`;

export const FormContainer = styled.div`
  text-align: center;

`;

export const CtaContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionTitleDark = styled.h2`
  color: #02391E;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
`;

export const SectionParagraphDark = styled.p`
  color: #02391E;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 30px;
  
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 850px;
  
`;

export const StyledInput = styled.input`
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  

  &:focus {
    outline: none;
    border-color: #02391E;
  }
`;

export const StyledTextarea = styled.textarea`
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
  color: #333;
  width: 100%;
  min-height: 120px;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #02391E;
  }
`;

export const SubmitButton = styled.button`
  background-color: #02391E;
  color: #ffffff;
  font-weight: 700;
  text-decoration: none;
  padding: 15px 40px;
  border-radius: 30px;
  border: 2px solid #02391E;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 16px;
  text-align: center;
  width: fit-content;
  align-self: center;

  &:hover {
    background-color: #ffffff;
    color: #02391E;
  }
`;

export const CtaImage = styled.img`
  max-width: 300px;
  margin-top: 30px;
  border-radius: 8px;
`;

export const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%; 
  height: 0;
  overflow: hidden;
  border-radius: 8px; 

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;


